// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import gql from 'graphql-tag'

const GET_SESSION = /*#__PURE__*/ gql`
    query {
      getSession
    }
  `,
  GET_INVITATIONS_BY_REFERENCE = /*#__PURE__*/ gql`
    query MyInvitationsByReferenceInput(
      $input: MyInvitationsByReferenceInput!
    ) {
      myInvitationsByReference(input: $input) {
        inviteeEmail
        invitedByEmail
        emailAcceptURL
        reference
        accessToken
      }
    }
  `

export {GET_SESSION, GET_INVITATIONS_BY_REFERENCE}
